import React from 'react';
import './DrawingColorPicker.css';

// Cores da marcação nos desenhos do prontuário (a primeira é a padrão)
export const DRAWING_COLORS = [
  { name: 'Vermelho', value: '#ff0000' },
  { name: 'Azul', value: '#0000ff' },
  { name: 'Verde', value: '#00e000' },
  { name: 'Amarelo', value: '#ffe600' },
  { name: 'Roxo', value: '#a000ff' },
  { name: 'Preto', value: '#000000' },
];

export const DEFAULT_DRAWING_COLOR = DRAWING_COLORS[0].value;

const DrawingColorPicker = ({ value, onChange }) => {
  const selected = DRAWING_COLORS.find((color) => color.value === value);

  return (
    <div className='drawing-color-picker' role='group' aria-label='Cor da marcação'>
      <span>Cor:</span>
      {DRAWING_COLORS.map((color) => (
        // type='button': o desenho fica dentro do Form do prontuário, e um botão sem tipo enviaria o formulário
        <button
          key={color.value}
          type='button'
          className={`drawing-color-swatch${color.value === value ? ' selected' : ''}`}
          style={{ backgroundColor: color.value }}
          title={color.name}
          aria-label={color.name}
          aria-pressed={color.value === value}
          onClick={() => onChange(color.value)}
        />
      ))}
      <span className='drawing-color-name'>{selected?.name}</span>
    </div>
  );
};

export default DrawingColorPicker;
